define([
    'componentsPreviewExtensions/visibilityPlugins/hiddenCompPlugin',
    'componentsPreviewExtensions/visibilityPlugins/hiddenCompPropertyPlugin',
    'componentsPreviewExtensions/visibilityPlugins/fixedPositionPlugin',
    'componentsPreviewExtensions/visibilityPlugins/appControllerPlugin'
], function (hiddenCompPlugin, hiddenCompPropertyPlugin, fixedPositionPlugin, appControllerPlugin) {
    'use strict';

    return {
        hiddenCompPlugin, hiddenCompPropertyPlugin, fixedPositionPlugin, appControllerPlugin
    };
});